import { useState } from "react";
import { ChevronDown, FolderClosed } from "lucide-react";

function Fold({ id, title, hint, n, children, always = false }) {
  const [open, setOpen] = useState(false);
  if (!n && !always) return null;
  return (
    <div className="border-b border-slate-200" data-testid={`portal-section-${id}`}>
      <button type="button" onClick={() => n && setOpen(!open)} disabled={!n} aria-expanded={open} data-testid={`portal-section-${id}-toggle`}
        className="w-full flex items-center gap-3 px-1 py-3.5 text-left disabled:cursor-default">
        <FolderClosed size={20} className={`${n ? "brand-text" : "text-slate-300"} shrink-0`} />
        <span className="flex-1 min-w-0">
          <span className={`block text-[15px] font-semibold ${n ? "text-slate-800" : "text-slate-400"}`} title={hint}>{title} ({n})</span>
        </span>
        {n > 0 && <ChevronDown size={18} className={`text-slate-400 transition-transform ${open ? "rotate-180" : ""}`} />}
      </button>
      {open && <div className="pb-3 space-y-3" data-testid={`portal-section-${id}-list`}>{children}</div>}
    </div>
  );
}

// O que já não precisa do cliente: fechado por omissão.
export function DocSections({ review, done, card, doneExtra = null }) {
  return (
    <div data-testid="portal-pending">
      <Fold id="review" always title="Documentos em análise" hint="Já recebemos — a equipa está a verificar." n={review.length}>{review.map((d) => card(d))}</Fold>
      <Fold id="done" title="Já enviados" hint="Documentos aceites — não precisa de fazer mais nada." n={done.length + (doneExtra ? 1 : 0)}>{done.map((d) => card(d))}{doneExtra}</Fold>
    </div>
  );
}
